import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchOmsSettings = unaryStreamRpc({
  name: "watchOmsSettings",
  input: z.object({}),
  output: z.object({ isRedoConnectDisabled: z.boolean() }),
});
